import React, { memo } from 'react';
import { WebContent } from 'js/components/system/WebContent';

import * as Types from './types';
import { GamesHeader } from '../GamesHeader';

import style from './GamesWebContentView.scss';

export const GamesWebContentViewBare: React.FC<Types.IGamesWebContentViewProps> = ({
    feedName,
    categoryName,
    categoryWebContent
}) => {

    return (
        <>
            <GamesHeader
                feedName={feedName}
                categoryName={categoryName}
            />
            <div className={`${style.webContentView} cms-games-grid-category-webcontent`}>
                <WebContent showLoader={false} id={categoryWebContent} />
            </div>
        </>
    );
};

export const GamesWebContentView = memo(GamesWebContentViewBare);
